/* JIMMY · choix de l'offre, compte à rebours, avis dépliables, barre d'achat fixe */
(function () {
  function initBundles(root) {
    root.querySelectorAll('[data-jimmy-bundle]').forEach(function (bundle) {
      if (bundle.dataset.ready) return;
      bundle.dataset.ready = '1';
      var formId = bundle.dataset.formId;

      function apply(input) {
        bundle.querySelectorAll('.jimmy-bundle__card').forEach(function (card) {
          card.classList.toggle('is-selected', card.contains(input));
        });
        document.querySelectorAll('form[id="' + formId + '"] input[name="id"], input[name="id"][form="' + formId + '"]').forEach(function (idInput) {
          idInput.value = input.value;
          idInput.disabled = false;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
        // Les prix affichés (sous le titre, barre mobile) suivent le palier choisi.
        var card = input.closest('.jimmy-bundle__card');
        if (card) {
          document.querySelectorAll('[data-jimmy-price-now]').forEach(function (el) { el.textContent = card.dataset.price; });
          document.querySelectorAll('[data-jimmy-price-compare]').forEach(function (el) {
            el.textContent = card.dataset.compare;
            el.hidden = !card.dataset.compare;
          });
        }
        document.dispatchEvent(new CustomEvent('jimmy:bundle-change', { detail: { variantId: input.value } }));
      }

      bundle.addEventListener('change', function (event) {
        if (event.target.matches('input[type="radio"]')) apply(event.target);
      });
      var checked = bundle.querySelector('input[type="radio"]:checked');
      if (checked) apply(checked);
    });
  }

  function parseEnd(value) {
    // « AAAA-MM-JJ HH:MM » lu comme heure de Paris (UTC+1 en hiver, UTC+2 en été)
    var m = (value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!m) return null;
    var asUtc = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    var parisOffset = new Date(asUtc).toLocaleString('en-US', { timeZone: 'Europe/Paris', timeZoneName: 'shortOffset' }).match(/GMT([+-]\d+)/);
    var hours = parisOffset ? parseInt(parisOffset[1], 10) : 1;
    return asUtc - hours * 3600 * 1000;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdowns(root) {
    root.querySelectorAll('[data-jimmy-countdown]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var end = parseEnd(el.dataset.end);
      var out = el.querySelector('[data-jimmy-countdown-time]');
      if (!end || !out) { el.hidden = true; return; }
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          out.textContent = el.dataset.ended || '';
          el.classList.add('is-ended');
          return;
        }
        var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), mi = Math.floor((left % 3600) / 60), s = left % 60;
        out.textContent = (d > 0 ? d + 'j ' : '') + pad(h) + ':' + pad(mi) + ':' + pad(s);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  function initReviews(root) {
    root.querySelectorAll('[data-jimmy-review-more]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      var text = btn.previousElementSibling;
      if (text && text.scrollHeight <= text.clientHeight + 2) { btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        var open = text.classList.toggle('is-open');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    });
  }

  function initSticky(root) {
    root.querySelectorAll('[data-jimmy-sticky]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var target = document.querySelector('product-form, .product-form');
      if (!target) return;
      // Visible dès que le bouton d'achat est passé au-dessus de l'écran.
      var update = function () { bar.classList.toggle('is-visible', target.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', update, { passive: true });
      update();
      bar.querySelector('[data-jimmy-sticky-button]').addEventListener('click', function () {
        var btn = document.querySelector('product-form button[type="submit"], .product-form__submit');
        if (btn) btn.click();
      });
    });
  }

  function initSliders(root) {
    root.querySelectorAll('[data-jimmy-slider]').forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      var track = slider.querySelector('.jimmy-slider__track');
      function step(dir) {
        var item = track.firstElementChild;
        var w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var prev = slider.querySelector('[data-jimmy-prev]');
      var next = slider.querySelector('[data-jimmy-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  function initAll(root) {
    initSliders(root);
    initBundles(root);
    initCountdowns(root);
    initReviews(root);
    initSticky(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* Panier : + et − passent d'une offre à l'autre (1 pot → 2 pots → 2 achetés + 1 offert) au lieu d'ajouter des pots au prix unitaire. */
(function () {
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.jimmy-drawer .quantity__button');
    if (!btn) return;
    var row = btn.closest('.cart-item');
    var tier = row && row.querySelector('.jimmy-tier');
    if (!tier) return;
    e.preventDefault();
    e.stopPropagation();

    var ids = tier.dataset.variants.split(',');
    var pos = parseInt(tier.dataset.pos, 10);
    var qty = parseInt(tier.dataset.qty, 10);
    var current = tier.dataset.variant;
    var plus = btn.name === 'plus';
    row.style.opacity = '0.5';
    row.style.pointerEvents = 'none';

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
        var updates = {};
        var target = null;
        if (plus && pos < ids.length && qty === 1) target = ids[pos];
        else if (!plus && pos > 1 && qty === 1) target = ids[pos - 2];

        if (plus && !target) {
          updates[current] = qty + 1; // meilleure offre (ou plusieurs offres) : une offre de plus
        } else if (target) {
          updates[current] = qty - 1; // une unité change d'offre
          updates[target] = (inCart[target] || 0) + 1;
        } else {
          updates[current] = qty - 1; // − : une offre de moins (retire la ligne à 0)
        }
        return postJSON((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
          updates: updates,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        });
      })
      .then(function (state) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || !state.sections) return location.reload();
        drawer.renderContents(state);
        if (state.item_count === 0) {
          drawer.classList.add('is-empty');
          var items = drawer.querySelector('cart-drawer-items');
          if (items) items.classList.add('is-empty');
        }
      })
      .catch(function () { location.reload(); });
  }, true);
})();
